export enum EditModalContext {
  CurrentStatus = "Edit current status & available by date",
  RentAmount = "Edit rent amount"
}
